// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yoho","newExpiryDate":"styles_newExpiryDate__1JL21","footer":"styles_footer__OpKk3"};